<template>
  <v-container fluid>
    <div :class="['post-view', selected ? 'post-view--active' : '' , ready ? 'post-view--ready' : '' ]">
      <div class="post-view__image"
           :style="'background-image:url('+postImage+');clip-path:'+clipPath">
      </div>
      <div class="post-view__container"
           v-if="selected">
        <div class="post-controls">
          <div class="post-control post-control--close"
               @click="closePost()">
            <v-icon>clear</v-icon>
          </div>
          <div class="post-control"
               id="prev-post"
               @click="prevPost()"
               v-show="currentPost.id !== 1">
            <v-icon>arrow_upward</v-icon>
          </div>
          <div class="post-control"
               id="next-post"
               @click="nextPost()">
            <v-icon>arrow_downward</v-icon>
          </div>
        </div>
        <v-card flat
                style="border-radius:0!important">
          <h2 class="post-view__title mx-2">{{currentPost.title}}</h2>
          <h3 class="post-view__date mx-2">{{currentPost.date}}</h3>
          <v-divider></v-divider>
        </v-card>

        <div class="post-view__content"
             v-html="currentPost.description"></div>
      </div>
    </div>
    <div :class="['post-list', selected ? 'post-list--hide' : '']">
      <div class="post"
           v-for="(item, index) in posts"
           :key="(item, index)"
           v-on:mouseenter="changePost(index)"
           @click="selectedPost(index)">
        <h2 class="post__title">{{item.title}} <span class="post__date">{{item.date}}</span></h2>
      </div>
    </div>
  </v-container>
</template>

<script>
const posts = [
  {
    id: 1,
    title: "Improving your Web Designs",
    date: "2021",
    description:
      '<p>As a web engineer, your career can be very hectic. New tools, design trends, user experience patterns, and more is constantly keeping you out of the loop and popping up all over the place. Don&#39;t worry though! There are plenty of resources available online for you to learn from. I have compiled some tips here for Website Engineers looking to improve their careers with web design.</p> <h1 id="learn-the-basics">Learn the Basics</h1> <p>I can&#39;t stress this enough. You are going to want to learn what is the very foundation of website design. 99design has a post on the <a href="https://99designs.com/blog/tips/web-design-basics-guide/">4 key principles of web design</a>. In this article, the foundations are:</p> <ol> <li>Grid Systems</li> <li>Visual hierarchy</li> <li>Web-safe fonts</li> <li>Images and colors</li> </ol> <h1 id="learn-to-communicate">Learn to Communicate</h1> <p>Learn to communicate not only in your design but with others. Getting better at working with others is a valuable asset in your career. Also, people on the web tend to want information quickly, so it is important to communicate clearly and make your information easy to read and digest. Some effective tactics to include in your web design include: organizing information using headlines and sub headlines, using bullet points instead of long windy sentences.</p> <h1 id="learn-to-use-great-tools">Learn Tooling</h1> <p>The tools you use are the bread and butter of your process. Here are some great tools:</p> <ul> <li><a href="https://bootstrap.build/app/" title="https://bootstrap.build/app/">https://bootstrap.build/app</a></li> <li><a href="https://www.photopea.com/" title="https://www.photopea.com/">https://www.photopea.com/</a></li> <li><a href="https://vscode.dev/" title="https://vscode.dev/">https://vscode.dev/</a></li> <li><a href="https://github.com/blakejs?tab=stars" title="https://github.com/blakejs?tab=stars">https://github.com/blakejs?tab=stars</a></li> </ul> <br> <p>My advice is: pick a tool and stick with it. Learning the inner workings of your chosen tools offers so many benefits because you get more and more productive.</p> <h1 id="learn-interview-questions">Learn Questions</h1> <p>Learning how an interview works is great because it makes you stand out and acing the interview means you know your stuff . If you can navigate the interview process, you can make your chances of landing the job greater. Here are a few resources to help you with the interview process:</p> <ul> <li><a href="https://github.com/MaximAbramchuck/awesome-interview-questions" title="https://github.com/MaximAbramchuck/awesome-interview-questions">https://github.com/MaximAbramchuck/awesome-interview-questions</a></li> <li><a href="https://www.usertesting.com/blog/interview-questions-to-ask-web-designers-the-secret-list/" title="https://www.usertesting.com/blog/interview-questions-to-ask-web-designers-the-secret-list/">https://www.usertesting.com/blog/interview-questions-to-ask-web-designers-the-secret-list/</a></li> <li><a href="https://www.upwork.com/hire/web-designers/interview-questions/" title="https://www.upwork.com/hire/web-designers/interview-questions/">https://www.upwork.com/hire/web-designers/interview-questions/</a></li> <li><a href="https://blog.hubspot.com/agency/interview-questions-designers" title="https://blog.hubspot.com/agency/interview-questions-designers">https://blog.hubspot.com/agency/interview-questions-designers</a></li> </ul> <h1 id="finally-do-not-stop-learning">Finally: Don&#39;t stop <del>BELIEVING</del> Learning</h1> <p>If you notice a trend in these tips it is learn, learn, learn, learn. It takes continuous learning to stay up-to-date on trends and on top of the industry. This means reading blogs, reading books, listening to podcast, watching videos, trying new things, getting your hands dirty, or looking at inspiration like the Hall of Fame for Website designs (<a href="https://www.awwwards.com/" title="https://www.awwwards.com/">https://www.awwwards.com/</a>).</p>',
    image: "/static/misc/u-1.jpg",
    clip_path: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)"
  },
  {
    id: 2,
    title: "Getting Traffic to a Site",
    date: "2021",
    description:
      '<p>In today&#39;s day and age, Organic Search Engine Traffic is critical to having a successful website. Let&#39;s break down why this is and how important it is. So, when someone online searches for something with a search engine they use keywords to try to find what they are looking for. According to a June 2013 study by <a href="https://en.wikipedia.org/wiki/Chitika">Chitika</a>, <a href="https://blog.hubspot.com/insiders/inbound-marketing-stats">9 out of 10 searchers don&#39;t go beyond Google&#39;s first page of organic search results</a>. Studies have also found that the <a href="https://www.searchenginewatch.com/2013/06/20/no-1-position-in-google-gets-33-of-search-traffic-study/">No. 1 Position in Google Gets 33% of Search Traffic</a>. This traffic is what is referred to as <a href="https://en.wikipedia.org/wiki/Organic_search">Organic Search Traffic</a>.</p> <h2 id="the-importance-of-organic-search-traffic-">The importance of Organic Search Traffic.</h2> <p><img style="width:100%" loading="lazy" src="/static/upload/dl2.jpg" alt="Organic vs non-organic and ad content search results"></p> <p>Why is this traffic important? Because every visitor is going there to want to find information fast and easy. If the page doesn&#39;t load fast or have the information they want then they will just leave and go on to the next thing. This type of traffic also excludes advertisements and considering that <a href="https://blog.hubspot.com/insiders/inbound-marketing-stats">over 80% of people ignore Google-sponsored ads or use adblock</a> this is incredibly important for generating genuine visitors and true leads. So, when someone reaches your website from a targeted keyword or copy, the chances are higher that they will consider even reading about your thing. Therefore, targeting your niche with keywords AND great content meant for them can bring in a lot of genuine traffic which equal potential relationships.</p> <h2 id="so-why-do-new-websites-and-blogs-struggle-to-get-organic-search-engine-traffic-">So, why do new websites and blogs struggle to get organic search engine traffic?</h2> <p>There are a number of reasons why your website isn&#39;t generating organic traffic. To list a few common mistakes:</p> <ul> <li><a href="https://juggler.com.au/news/fake-backlinks-and-how-some-companies-are-still-tricking-google/">Trying to trick Search Engines</a></li> <li><a href="https://trafficgenerationcafe.com/google-sandbox-effect/">Google Sandbox Effect</a></li> <li><a href="https://developers.google.com/search/docs/advanced/guidelines/irrelevant-keywords">Keyword Stuffing</a></li> <li><a href="https://developers.google.com/search/docs/advanced/guidelines/thin-content">Lack of content</a></li> </ul> <br> <p>In general, the reason people are not visiting these sites that show up lower in the search rankings is because there is no content for them, the sites SEO is very poor and lacking or these sites are trying to trick the system causing them to rank lower on search engines (along with a lot more reasons that affect SEO..). Gone are the days of: Keyword Saturation, Forum and Blog commenting, Guest blogging at scale, and many other old SEO tactics.</p> <h2 id="great-content-wins-every-time-">Epic content wins every time.</h2> <p>You can&#39;t trick search engines anymore. At the end of the day: <br><img loading="lazy" style="width:100%" src="/static/upload/dl3.jpg" alt="misty church"><br> Those who frequently publish good content shall find the hidden treasure. The proven method to generating organic traffic is to <a href="https://www.huffingtonpost.com/chad-pollitt/the-best-place-to-hide-a-_b_5168714.html">&quot;deliver utility and useful content to the audiences that frequent your website&quot;</a>. Also, strategies like writing quality, using proper keywords, titles, URLS, etc. should be standardized across your niche content. As you make more and more <a href="https://contentmarketinginstitute.com/what-is-content-marketing/">quality content</a> the affect it has on your rankings <a href="https://en.wikipedia.org/wiki/The_Snowball%3A_Warren_Buffett_and_the_Business_of_Life">snowball</a>.</p>',
    image: "/static/misc/u-2.jpg",
    clip_path: "polygon(24% 0, 90% 30%, 79% 78%, 13% 76%)"
  },
];
export default {
  data() {
    return {
      test: "",
      posts: posts,
      selectedClipPath: "polygon(0 100%, 0 0, 100% 0, 100% 100%)",
      postImage: posts[0].image,
      currentPost: null,
      postIndex: 0,
      selected: false,
      ready: false,
      lastSelectedPost: null,
      clipPath: posts[0].clip_path
    };
  },
  methods: {
    changePost(index) {
      if (this.postImage != this.posts[index].image && this.selected == false) {
        this.postImage = this.posts[index].image;
        this.clipPath = this.posts[index].clip_path;
      }
    },
    closePost() {
      if (this.lastSelectedPost != null) {
        this.selected = false;
        this.ready = false;
        this.clipPath = this.posts[this.lastSelectedPost].clip_path;
      }
    },
    selectedPost(index) {
      this.selected = true;
      this.clipPath = this.selectedClipPath;
      this.lastSelectedPost = index;
      this.currentPost = this.posts[index];
      window.scroll(0, 0);
      setTimeout(() => {
        this.ready = true;
      }, 600);
    },
    nextPost() {
      if (this.lastSelectedPost < this.posts.length - 1) {
        this.lastSelectedPost++;
        this.ready = false;
        setTimeout(() => {
          this.currentPost = this.posts[this.lastSelectedPost];
          this.postImage = this.currentPost.image;
          this.ready = true;
        }, 600);
      }
    },
    prevPost() {
      if (
        this.lastSelectedPost <= this.posts.length - 1 &&
        this.lastSelectedPost != 0
      ) {
        this.lastSelectedPost--;
        this.ready = false;
        setTimeout(() => {
          this.currentPost = this.posts[this.lastSelectedPost];
          this.postImage = this.currentPost.image;
          this.ready = true;
        }, 600);
      } else {
      }
    }
  },
  created() {
    window.addEventListener("keydown", e => {
      e.keyCode == 39 ? this.nextPost() : false;
      e.keyCode == 37 ? this.prevPost() : false;
      e.keyCode == 27 ? this.closePost() : false;
    });
  },
  name: "Garden"
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
body {
  font-family: "Inconsolata", monospace;
}
.post-view__content a {
  color: mediumblue !important;
}
.container {
  max-width: 100vw;
  background: linear-gradient(270deg, #9bf6dc60, #43cdf360);
  align-items: center;
  display: flex;
  height: auto;
}
.post {
  cursor: pointer;
  margin-bottom: 50px;
}
.post__date {
  display: block;
  width: 100%;
  font-family: "Inconsolata", monospace;
  font-size: 0.9em;
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: normal;
}
.post__title {
  font-family: "Roboto Mono", monospace;
  font-size: 2em;
  padding: 12px 30px;
  font-weight: bold;
  position: relative;
}
.post__title:after {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0;
  z-index: -1;
  transition: width 0.3s ease 0s;
  content: "";
  background: #c6e5f1;
  transform: skew(-20deg);
}
.post__title:hover:after {
  width: 100%;
}
.post:last-child {
  margin-bottom: 0;
}
.post-list {
  display: flex;
  justify-content: center;
  padding: 30px 20px 0;
  width: 95%;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  transition: all 0.3s ease 0s;
  transform: translateY(0px);
  visibility: visible;
}
.post-list--hide {
  transform: translateY(-20px);
  opacity: 0;
  visibility: hidden;
}
.post-view {
  transition: 0.3s ease 0s;
  min-width: 100%;
  min-height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: inherit;
  background: #e1fcf5;
}
.post-view__date {
  font-family: "Inconsolata", monospace;
  margin-bottom: 0px;
  transform: translateY(45px);
  transition: transform 0.3s ease 0s;
}
.post-view__image {
  position: fixed;
  transition: all 0.5s ease 0s;
  clip-path: polygon(80% 0%, 100% 100%, 80% 100%, 50% 50%);
  width: 800px;
  background-size: cover;
  overflow: hidden;
  height: 500px;
  top: 50%;
  left: 45%;
  margin-top: -225px;
  background-position: center;
}
.post-view__container {
  top: 100px;
  width: 98%;
  max-width: 900px;
  z-index: 2;
  opacity: 0;
  transition: all 0.3s ease 0s;
}
.post-view__content {
  font-size: 1.2em;
  background: #fff;
  padding: 40px 15px 80px;
  margin-bottom: 20px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
  transform: translateY(85px);
  transition: transform 0.3s ease 0s;
  contain: content;
  word-break: break-word;
}
.post-view__content p {
  font-size: 1.3em;
  margin-bottom: 30px;
  line-height: 25px;
}
.post-view__content p:last-child {
  margin-bottom: 0;
}
.post-view__content[*] img.img-small {
  width: 100%;
}
.post-view--active .post-view__image {
  background-position: top;
  transition: all 0.6s ease 0s;
  width: 100%;
  height: 300px;
  margin-top: 0;
  top: 0;
  left: 0;
}
.post-view__title {
  font-family: "Roboto Mono", monospace;
  font-size: 2.875em;
  font-weight: bold;
  margin: 30px 0 15px 0;
  transform: translateY(45px) scaleY(0);
  transition: transform 0.3s ease-out 0s;
}
.post-view--ready .post-view__container {
  opacity: 1;
}
.post-view--ready .post-view__date,
.post-view--ready .post-view__content {
  transform: translateY(0px);
}
.post-view--ready .post-view__title {
  transform: translateY(0px) scaleY(1);
}
.post-controls {
  position: fixed;
  right: 50px;
  flex-direction: column;
  top: 100px;
  display: flex;
}
.post-control {
  cursor: pointer;
  font-size: 1.375em;
  background: #55efc4;
  margin-bottom: 15px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  text-align: center;
  line-height: 43px;
  transition: all 0.3s ease 0s;
}
.post-control:hover {
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}
.post-control--close {
  background: #fff;
}
.post-control--close:hover {
  background: #00000080;
}
@media (max-width: 1263px) {
  .post__title {
    padding: 0;
  }
  .post-list {
    padding: 0;
    align-items: center;
  }
  .container {
    display: flex;
    justify-content: center;
  }
  .post-view__image {
    align-self: center;
    width: 90%;
    left: 20px;
  }
  .post-controls {
    bottom: 50px;
    z-index: 99;
    top: auto;
    background: rgba(0, 0, 0, 0.5);
    padding: 0 5px;
    justify-content: center;
    margin: auto;
    border-radius: 30px;
    height: 55px;
    align-items: center;
    flex-direction: row-reverse;
  }
  .post-control {
    margin: 0 5px;
  }
  .post-control--close {
    background: #fff;
  }
  .post-view__container {
    width: 100%;
    padding: 0;
  }
  .post-view__image {
    display: none;
  }
  .post-view--ready .post-view__image {
    display: block;
  }
  img.img-small {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Garden.vue